export var allPartnersCompanyGroupCode = "ALL_PARTNERS";
export var removeConfirmationWord = "DELETE";
export var downloadMimeType = "application/octet-stream";
export var whistleBlowSystemUserCode = "SYSTEM";
export var minimumPasswordLength = 8;
export var maximumPasswordLength = 30;
export var totalTaskDataRowId = "totalRow";
//UserParameterCodes
export var userParameterShowPageNavigation = "ShowPageNavigation";
//OptionCode
export var optionCodeTaskTypeExpressionInfoDocument = "TaskTypeExpressionInfoDocument";
//Mobile
export var infiniteListPageSize = 30;
export var infiniteListPageHalfSize = 15;
